import cn from 'classnames';
import { ReactNode } from 'react';
import { FieldValues, UseControllerProps, useController } from 'react-hook-form';

import s from './styles.module.css';

interface ISelectionProps<
  TFieldValues extends FieldValues,
> extends UseControllerProps<TFieldValues> {
  value: string;
  title: ReactNode;
  description?: ReactNode;
}

const Selection = <TFieldValues extends FieldValues>({
  value,
  title,
  description,
  name,
  rules,
  control,
  defaultValue,
  shouldUnregister,
}: ISelectionProps<TFieldValues>) => {
  const { field } = useController({
    name,
    rules,
    control,
    defaultValue,
    shouldUnregister,
  });

  return (
    <label htmlFor={value} className={s.wrapper}>
      <input
        className={s.input}
        {...field}
        id={value}
        type="radio"
        value={value}
        checked={value === field.value}
      />
      <div key={value} className={cn(s.card, { [s.checked]: value === field.value })}>
        <div className={s.labels}>
          <div className={s.title}>{title}</div>
          {description && <div className={s.description}>{description}</div>}
        </div>
        <div className={s.checkRing} />
      </div>
    </label>
  );
};

export { Selection };
